// extracted by mini-css-extract-plugin
export var avatarContainer = "_i2-0";
export var avatarTypingWave = "_i2-i";
export var gray = "_i2-f";
export var green = "_i2-c";
export var icon = "_i2-9";
export var image = "_i2-1";
export var lg = "_i2-6";
export var md = "_i2-5";
export var presenceDot = "_i2-b";
export var red = "_i2-d";
export var sm = "_i2-4";
export var status = "_i2-a";
export var typingDot = "_i2-h";
export var typingPill = "_i2-g";
export var xl = "_i2-7";
export var xs = "_i2-3";
export var xxl = "_i2-8";
export var xxs = "_i2-2";
export var yellow = "_i2-e";